const getDateUTCString = (date) => `${date.getUTCFullYear()}-${(date.getUTCMonth()+1).toString().padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;

export default getDateUTCString
